import { render, staticRenderFns } from "./umap_regularGene.vue?vue&type=template&id=0bf9e129&scoped=true&"
import script from "./umap_regularGene.vue?vue&type=script&lang=js&"
export * from "./umap_regularGene.vue?vue&type=script&lang=js&"
import style0 from "./umap_regularGene.vue?vue&type=style&index=0&id=0bf9e129&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9e129",
  null
  
)

export default component.exports